import { useEffect, useState } from "react";
import Model, { helper, Providers } from "@tripian/model";
import { providers } from "@tripian/core";
import { ensureLivnInventoryCache, isLivnProductDisabled } from "../providers/livn/inventoryCache";

// Livn category IDs mapped to our standard catalog groups
const initialCatalog: Providers.Livn.CatalogGroup[] = [
  { title: "Adventure", items: [], categoryIds: [1, 7, 15, 16, 23, 24, 25] },
  { title: "Food", items: [], categoryIds: [9] },
  { title: "Culture History", items: [], categoryIds: [8] },
  { title: "Sightseeing", items: [], categoryIds: [3, 5, 10, 11, 22] },
  { title: "Art Museum", items: [], categoryIds: [6, 13] },
  { title: "Local Neighborhood", items: [], categoryIds: [18, 19] },
  { title: "Events", items: [], categoryIds: [21] },
  { title: "Others", items: [], categoryIds: [] },
];

const useLivnCatalog = (lat?: number, lng?: number, arrivalDate?: string, departureDate?: string) => {
  const isLivnActive =
    typeof window !== "undefined" &&
    window.tconfig &&
    Array.isArray(window.tconfig.TOUR_TICKET_PROVIDER_IDS)
      ? window.tconfig.TOUR_TICKET_PROVIDER_IDS.includes(Model.PROVIDER_ID.LIVN)
      : false;

  const [livnProducts, setLivnProducts] = useState<Providers.Livn.Product[]>();
  const [livnToursCatalog, setLivnToursCatalog] =
    useState<Providers.Livn.CatalogGroup[]>(initialCatalog);
  const [loadingLivnTourCatalog, setLoadingLivnTourCatalog] =
    useState<boolean>(isLivnActive);

  useEffect(() => {
    if (livnProducts !== undefined) {
      setLoadingLivnTourCatalog(true);
      const newCatalog: Providers.Livn.CatalogGroup[] = helper.deepCopy(initialCatalog);

      livnProducts.forEach(product => {
        if (!product.categories || !Array.isArray(product.categories)) return;

        let matched = false;

        for (const catalog of newCatalog) {
          if (catalog.categoryIds.length > 0 && product.categories.some(c => catalog.categoryIds.includes(c.id))) {
            catalog.items.push(product);
            matched = true;
            break;
          }
        }

        if (!matched) {
          const othersCatalog = newCatalog.find(c => c.title === "Others");
          if (othersCatalog) othersCatalog.items.push(product);
        }
      });

      setLivnToursCatalog(newCatalog);
      setLoadingLivnTourCatalog(false);
    }
  }, [livnProducts]);

  useEffect(() => {
    if (
      window.tconfig.TOUR_TICKET_PROVIDER_IDS.some(x => x === Model.PROVIDER_ID.LIVN) &&
      providers.livn &&
      lat !== undefined &&
      lng !== undefined &&
      window.tconfig.SHOW_TOURS_AND_TICKETS
    ) {
      setLoadingLivnTourCatalog(true);
      Promise.all([providers.livn.productSearch(lat, lng, arrivalDate, departureDate), ensureLivnInventoryCache()])
        .then(([response]: [Providers.Livn.ProductSearchResponse, void]) => {
          const activeProducts = response.products.filter(p => !p.disabled && !isLivnProductDisabled(p.id));
          setLivnProducts(activeProducts);
        })
        .catch((err: unknown) => {
          console.error("Livn Fetch Tours Error:", err);
          setLoadingLivnTourCatalog(false);
        })
        .finally(() => setLoadingLivnTourCatalog(false));
    }
  }, [lat, lng, arrivalDate, departureDate]);

  return {
    livnToursCatalog,
    loadingLivnTourCatalog,
  };
};

export default useLivnCatalog;
